/* unplugin-vue-components disabled */import script from "./TopNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNav.vue?vue&type=script&setup=true&lang=js"

import "./TopNav.vue?vue&type=style&index=0&id=fda81fe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fda81fe4"]])

export default __exports__